// src/json/overlayData.json
export const overlaySectionCommercialInteriorPainting = {
    imageUrl: "/assets/imgs/services/5CommercialInteriorPainting/overlaySection/fondo.jpg",
    text: "The best Building Envelope Renewal /",
    highlight: "High-Rise Painting & Restoration services."
};
